import React from "react";
import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import LogoImage from "../school_images/gdgoenkalogo.png";
import "../styleCSS/tenetsStyle.css";
import NoticeEvents from "./NoticeEvents";
import Footer from "../components/Footer";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import tenet1_image from "../school_images/connectivity_image_for_School.jpg";
import tenet2_image from "../school_images/tenet_2.jpg";
import tenet3_image from "../school_images/tenet3_image.jpg";
import tenet4_image from "../school_images/connectivity_image_for_School.jpg";
import { FaAnglesRight } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";

const HeroTenetsSection = () => {
  // Sample links data for each card
  const cardLinks = {
    legitimacy: [
      { text: "About Our Legacy", url: "/legacy" },
      { text: "Accreditations", url: "/accreditations" },
      { text: "History", url: "/history" },
      { text: "Leadership", url: "/leadership" }
    ],
    synergy: [
      { text: "Partnerships", url: "/partnerships" },
      { text: "Collaborations", url: "/collaborations" },
      { text: "Community", url: "/community" },
      { text: "Networking", url: "/networking" }
    ],
    proficiency: [
      { text: "Academics", url: "/academics" },
      { text: "Faculty", url: "/faculty" },
      { text: "Curriculum", url: "/curriculum" },
      { text: "Excellence", url: "/excellence" }
    ],
    prospects: [
      { text: "Career Opportunities", url: "/careers" },
      { text: "Alumni Success", url: "/alumni" },
      { text: "Future Programs", url: "/programs" },
      { text: "Growth", url: "/growth" }
    ]
  };

  return (
    <HeroTenetsDiv>
      <BelowHeroDiv>
        <FourTenetsHead>
          <h1>The Four Tenets</h1>
          <p>
            With roots of LEGITIMACY growing into stems of SYNERGY, flowers of
            PROFICIENCY bloom into fruits of PROSPECTS.
          </p>
        </FourTenetsHead>
      </BelowHeroDiv>
      
      <FourTenets>
        <FlipCard>
          <FlipCardInner>
            <FlipCardFront>
              <img src={tenet1_image} alt="legitimacy" />
              <h3>LEGITIMACY</h3>
              <Link to="/legitimacy">Read More...</Link>
            </FlipCardFront>
            <FlipCardBack>
              <h3>LEGITIMACY</h3>
              <LinksList>
                {cardLinks.legitimacy.map((link, index) => (
                  <li key={index}>
                    <Link to={link.url}>
                      <FaArrowRightLong /> {link.text}
                    </Link>
                  </li>
                ))}
              </LinksList>
            </FlipCardBack>
          </FlipCardInner>
        </FlipCard>

        <FlipCard>
          <FlipCardInner>
            <FlipCardFront>
              <img src={tenet2_image} alt="synergy" />
              <h3>SYNERGY</h3>
              <Link to="/synergy">Read More...</Link>
            </FlipCardFront>
            <FlipCardBack>
              <h3>SYNERGY</h3>
              <LinksList>
                {cardLinks.synergy.map((link, index) => (
                  <li key={index}>
                    <Link to={link.url}>
                      <FaArrowRightLong /> {link.text}
                    </Link>
                  </li>
                ))}
              </LinksList>
            </FlipCardBack>
          </FlipCardInner>
        </FlipCard>

        <FlipCard>
          <FlipCardInner>
            <FlipCardFront>
              <img src={tenet3_image} alt="proficiency" />
              <h3>PROFICIENCY</h3>
              <Link to="/proficiency">Read More...</Link>
            </FlipCardFront>
            <FlipCardBack>
              <h3>PROFICIENCY</h3>
              <LinksList>
                {cardLinks.proficiency.map((link, index) => (
                  <li key={index}>
                    <Link to={link.url}>
                      <FaArrowRightLong /> {link.text}
                    </Link>
                  </li>
                ))}
              </LinksList>
            </FlipCardBack>
          </FlipCardInner>
        </FlipCard>

        <FlipCard>
          <FlipCardInner>
            <FlipCardFront>
              <img src={tenet4_image} alt="prospects" />
              <h3>PROSPECTS</h3>
              <Link to="/prospect">Read More...</Link>
            </FlipCardFront>
            <FlipCardBack>
              <h3>PROSPECTS</h3>
              <LinksList>
                {cardLinks.prospects.map((link, index) => (
                  <li key={index}>
                    <Link to={link.url}>
                      <FaArrowRightLong /> {link.text}
                    </Link>
                  </li>
                ))}
              </LinksList>
            </FlipCardBack>
          </FlipCardInner>
        </FlipCard>
      </FourTenets>
      
      <NoticeEvents />
      <Footer />
    </HeroTenetsDiv>
  );
};

export default HeroTenetsSection;

// Animations
const flipAnimation = keyframes`
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(180deg);
  }
`;

const flipBackAnimation = keyframes`
  0% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(0deg);
  }
`;

// Styled Components
const HeroTenetsDiv = styled.section`
  z-index: 999999899999;
`;

const BelowHeroDiv = styled.section`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FourTenetsHead = styled.div`
  font-family: "Roboto Slab", serif;
  padding-left: 2rem;
  padding-right: 2rem;
  
  h1 {
    font-weight: bold;
    font-size: 4vw;
    margin-top: 6vh;
    margin-bottom: 3vh;
    
    @media (max-width: 1200px) {
      font-size: 3rem;
    }
    
    @media (max-width: 768px) {
      font-size: 2.5rem;
      text-align: center;
    }
    
    @media (max-width: 480px) {
      font-size: 2rem;
    }
  }
  
  p {
    font-size: 3vw;
    
    @media (max-width: 1200px) {
      font-size: 1.5rem;
    }
    
    @media (max-width: 768px) {
      font-size: 1.2rem;
      text-align: center;
    }
    
    @media (max-width: 480px) {
      font-size: 1rem;
    }
  }
`;

const FourTenets = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin: 3% 7%;
  padding: 2%;
  background: #ddf5f5;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    margin: 3% 4%;
    padding: 1.5rem;
    gap: 1.5rem;
  }
  
  @media (max-width: 480px) {
    margin: 3% 2%;
    padding: 1rem;
    gap: 1rem;
  }
`;

const FlipCard = styled.div`
  perspective: 1000px;
  height: 350px;
  
  @media (max-width: 768px) {
    height: 320px;
  }
  
  @media (max-width: 480px) {
    height: 280px;
  }
`;

const FlipCardInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  
  ${FlipCard}:hover & {
    transform: rotateY(180deg);
  }
`;

const FlipCardFace = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const FlipCardFront = styled(FlipCardFace)`
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  
  img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 10px;
    margin-bottom: 1rem;
    
    @media (max-width: 768px) {
      height: 150px;
    }
    
    @media (max-width: 480px) {
      height: 120px;
    }
  }
  
  h3 {
    font-family: "Roboto Slab", serif;
    font-size: 1.5rem;
    font-weight: bold;
    text-transform: uppercase;
    color: #2c5282;
    margin-bottom: 1rem;
    text-align: center;
    
    @media (max-width: 768px) {
      font-size: 1.3rem;
    }
    
    @media (max-width: 480px) {
      font-size: 1.1rem;
    }
  }
  
  a {
    color: #3182ce;
    text-decoration: none;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    &:hover {
      color: #2c5282;
      text-decoration: underline;
    }
  }
`;

const FlipCardBack = styled(FlipCardFace)`
  background: linear-gradient(135deg, #2c5282 0%, #3182ce 100%);
  color: white;
  transform: rotateY(180deg);
  justify-content: flex-start;
  padding-top: 2rem;
  
  h3 {
    font-family: "Roboto Slab", serif;
    font-size: 1.5rem;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 1.5rem;
    text-align: center;
    
    @media (max-width: 768px) {
      font-size: 1.3rem;
    }
    
    @media (max-width: 480px) {
      font-size: 1.1rem;
    }
  }
`;

const LinksList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  
  li {
    margin-bottom: 0.8rem;
    
    @media (max-width: 480px) {
      margin-bottom: 0.6rem;
    }
  }
  
  a {
    color: white;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
    border-radius: 5px;
    transition: background-color 0.3s ease;
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
    
    svg {
      font-size: 0.8rem;
    }
  }
`;